import React, { useState } from 'react';
import eventImage from '../Images/event.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import UserService from '../Commons/UserService';

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    UserService.doLogin(username, password)
      .then(() => {
        navigate("/Homepage");
      })
      .catch(() => {
        Swal.fire("Login Failed!");
      });
  };

  // const handleLogin = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await fetch('/api/login', {  // Change to your backend URL
  //     // const res = await fetch('http://192.168.5.189:5000/api/login', {  // Change to your backend URL
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ username, password }),
  //     });

  //     const data = await res.json();

  //     if (res.ok && data.success) {
  //       // Login success
  //       navigate('/Homepage');
  //     } else {
  //       Swal.fire({
  //         text: data.message,
  //         icon: 'error'
  //       });
  //     }
  //   } catch (err) {
  //     Swal.fire({
  //       text: 'Server error. Please try again later.',
  //       icon: 'error'
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 py-4">
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[9999]">
          <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md flex flex-col items-center">
        <h1 className="text-2xl font-bold mb-4">Booking by IT</h1>
        <img src={eventImage} alt="logo" className="w-24 mb-6" />

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={handleKeyPress}
          className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyPress}
          className="w-full px-4 py-2 mb-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <button className="w-full font-bold bg-orange-500 text-white py-2 rounded hover:bg-orange-600 transition duration-200" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
}

export default Login;
